import { Paper, Typography, Stack, Button, Alert, Box } from "@mui/material";
import Section from "./Section";
import { Add } from "@mui/icons-material";
import { useContext, useState } from "react";
import useUpdateChapter from "../Hooks/useUpdateChapter";
import useDeleteChapter from "../Hooks/useDeleteChapter";
import Actions from "../Common/Actions";
import TitleForm from "../Common/TitleForm";
import useCreateChapter from "../Hooks/useCreateChapter";
import useCreateSection from "../Hooks/useCreateSection";
import Droppable from "../Common/Droppable";
import Draggable from "../Common/Draggable";
import API from "../../../services/API";
import UserContext from "../../../services/Context/UserContext";
import { txt } from "../../../services/translation";

export default function Chapter({data, sections, dragged}){

    const {user} = useContext(UserContext)

    const [titleForm, setTitleForm] = useState(data.edit ? true : false)

    const [drag, setDrag] = useState(false)

    const createChapter = useCreateChapter()
    const createSection = useCreateSection()
    const updateChapter = useUpdateChapter()
    const deleteChapter = useDeleteChapter()

    const handleNewTitle = title => {
        setTitleForm(false)
        updateChapter({...data, title})
    }

    const handleCopy = () => {
        const courseId = window.prompt("Entrez le code produit de la formation dans laquelle vous voulez copier le chapitre :");

        if(!courseId) return false;

        API.get(`/design/chapters/${data.id}/copy?course=${courseId}`)
            .then(r => console.log(r.data))
            .catch(e => console.log(e))
    }

    return <>

        <Stack>

            <Draggable id={data.id} data={{...data, isChapter: true}} disabled={!drag}>

                <Paper
                    variant='outlined'
                    sx={{p: 1}}
                    data-id={data.id}
                    data-rank={data.rank}
                >
                    {titleForm ?
                        <TitleForm
                            title={data.title}
                            onSubmit={handleNewTitle}
                            onCancel={() => setTitleForm(false)}
                        />
                        :
                        <Stack direction='row' alignItems='center'>

                            <Box sx={{flex:1}} onClick={() => setTitleForm(true)}>
                                {data.title ? 
                                    <Typography>{data.title}</Typography>
                                    :
                                    <Alert severity='warning'>{txt("addTitle")}</Alert>
                                }
                            </Box>

                            <Actions
                                onCopy={user.admin ? handleCopy : false}
                                onDelete={() => deleteChapter(data.id)}
                                onDrag={() => setDrag(true)}
                                onDrop={() => setDrag(false)}
                            />
                        </Stack>
                    }

                </Paper>

            </Draggable>

            <>

                <Droppable 
                    id={data.id + '-section0'} 
                    data={{rank: 0, chapter: data, isSection: true}}
                    disabled={!dragged?.isSection || (dragged?.chapter?.id === data.id && dragged?.rank === 1)}
                />

                {sections.map(s => 
                    <Stack key={s.id}>

                        <Section data={s} />

                        <Droppable 
                            id={s.id} 
                            data={{rank: s.rank + 0.5, chapter: s.chapter, isSection: true}}
                            disabled={!dragged?.isSection || dragged?.id === s.id}
                        />

                    </Stack>    
                )}

                <Stack alignItems='flex-start'>
                    <Button startIcon={<Add />} onClick={() => createSection(data)} sx={{ml: 5}}>
                        {txt('section')}
                    </Button>

                    <Button startIcon={<Add />} onClick={() => createChapter(data.rank + 1)}>
                        {txt('chapter')}
                    </Button>
                </Stack>

            </>

            <Droppable 
                id={data.id} 
                data={{rank: data.rank + 0.5, isChapter: true}}
                disabled={!dragged?.isChapter|| dragged?.id === data.id}
            />

        </Stack>

    </>
}